 'use strict';
(function () {
    angular
        .module('bidding')
        .component('biddingSelectedBidsComponent', {
            templateUrl: 'bidding/components/bidding-selected-bids-component.html',
            controller: function (EventManagerService, BiddingService,BiddingFactory, $timeout, $window) {
            	 var vm = this;
            	 
            	 vm.showTimeLine = false;
            	 vm.timeLineData = null;
            	 
            	 vm.viewType = 'M';
            	 vm.screen_left_panel = 0; 
            	 vm.numberOfDatesInCycle = 0;
            	 vm.blockWidth = 0;
            	 vm.scrollAreaWidth = 0;
            	 
            	 vm.selectedBiddings = [];
            	
            	 vm.selectedCrewBidding = null;
            	 
            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.UPDATE_BOTTOM_LINE_DATA, updateBottomTimelineInformation);
            	 
            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.DRAW_BOTTOM_LINE, renderTimeLine);
            	 
            	 EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_BIDDING.CLOSE_BOTTOM_LINE, closeBottomLine);
            	 
            	 angular.element($window).bind('resize',function(){
                  	vm.responsive_right_section_width = window.innerWidth - (vm.screen_left_panel + 66);
                 });
            	 
            	 vm.removeSelectedCrewBid = function(){
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.REMOVE_SELECTED_BID,vm.selectedCrewBidding);
            	 }
            	 
            	 vm.approveSelectedBids = function(){
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.APPROVE_SELECTED_BID);
            	 }
            	 
            	 vm.cancelApproveProcess = function(){
            		 vm.showTimeLine = false;
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.CANCEL_APPROVE_PROCESS, vm.showTimeLine);
            	 }
            	 
            	 function updateBottomTimelineInformation(viewData){
            		 vm.selectedBiddings = viewData.selectedBiddings;
                	 vm.showTimeLine = viewData.showTimeline;
            	 }
            	 
            	 function renderTimeLine(viewData){
            		 vm.timeLineData = viewData.timeLineData;
            		 vm.viewType = viewData.viewType;
                	 vm.screen_left_panel = viewData.screen_left_panel; 
                	 vm.numberOfDatesInCycle = viewData.numberOfDatesInCycle;
                	 vm.blockWidth = viewData.blockWidth;
                	 vm.scrollAreaWidth = vm.timeLineData.length * vm.blockWidth;
                	 vm.responsive_right_section_width = $window.innerWidth - (vm.screen_left_panel + 66);
            	 }
            	 
            	 function closeBottomLine(){
            		 vm.showTimeLine = false;
            		 EventManagerService.notifyEventListeners(EventManagerService.EVENT.RESET_BOTTOM_LINE_OPENED_FLAG,vm.showTimeLine);
            	 }
            	 
            	 vm.onClickSelectedCrewBidding = function(event,clickedBiddingRequest){
            		 vm.selectedCrewBidding =  clickedBiddingRequest;
            	 }
            	 	
            },
            bindings: {
               
            }
        })
})();

